import { render, staticRenderFns } from "./IconSvgCommunity.vue?vue&type=template&id=46905156&scoped=true&"
import script from "./IconSvgCommunity.vue?vue&type=script&lang=js&"
export * from "./IconSvgCommunity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46905156",
  null
  
)

export default component.exports